import api from "../api/axios";

  

const SaleService = {
 
    searchCustomer: async (params) => {
        const res = await api.get( "customer/sale-customer-search",params);
        return res.data.data || res.data;
    },
    searchProduct: async (params) => {
        const res = await api.get( "product/sale-product-search",params);
        return res.data.data || res.data;
    },
    createSale: async (data) => {
        const res = await api.post( "sales/create-sale",data);
        return res.data.data || res.data;
    },
    getSaleDetail: async (id) => {
        const res = await api.get(`sales/get-sale-detail/${id}`);
        return res.data.data || res.data;
    },
    updateSale: async (id, data) => {
        const res = await api.post(`sales/update-sale/${id}`, data);
        return res.data.data || res.data;
    }

};

export default SaleService;
